import { Skeleton } from './ui/skeleton';
import { Card, CardContent, CardHeader } from './ui/card';
import { Separator } from './ui/separator';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarInset,
  SidebarProvider,
  SidebarSeparator,
} from './ui/sidebar';

export const ArticleSectionBySectionSkeleton: React.FC = () => {
  return (
    <SidebarProvider>
      <div className="flex min-h-full w-full">
        <Sidebar side="left" className="border-r">
          <SidebarHeader>
            <div className="flex items-center gap-2 px-4 py-2">
              <Skeleton className="h-6 w-6" />
              <Skeleton className="h-6 w-28" />
            </div>
            <SidebarSeparator />
          </SidebarHeader>
          <SidebarContent>
            <SidebarGroup>
              <SidebarGroupLabel>
                <Skeleton className="h-4 w-24" />
              </SidebarGroupLabel>
              <SidebarGroupContent className="px-4">
                <Skeleton className="h-10 w-full" />
              </SidebarGroupContent>
            </SidebarGroup>
            <SidebarSeparator />
            <SidebarGroup>
              <SidebarGroupLabel>
                <Skeleton className="h-4 w-28" />
              </SidebarGroupLabel>
              <SidebarGroupContent className="px-4 space-y-2">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="flex items-center justify-between py-1">
                    <Skeleton className="h-4 w-32" />
                    <Skeleton className="h-5 w-10 rounded" />
                  </div>
                ))}
                <SidebarSeparator className="my-3" />
                <div className="flex items-center justify-between pt-1">
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-5 w-12 rounded" />
                </div>
              </SidebarGroupContent>
            </SidebarGroup>
          </SidebarContent>
        </Sidebar>

        <SidebarInset className="flex-1">
          <div className="flex items-center gap-2 px-4 py-2 border-b border-ochre/10 bg-paper-warm/30">
            <Skeleton className="h-6 w-6" />
            <Separator orientation="vertical" className="mr-2 h-6" />
            <Skeleton className="h-4 w-24" />
          </div>

          <div className="border-b border-ochre/10 bg-paper-warm/30 px-6 py-8">
            <div className="container mx-auto space-y-2">
              <Skeleton className="h-8 w-48" />
              <Skeleton className="h-5 w-80" />
            </div>
          </div>

          <div className="border-b px-4 py-3">
            <div className="container mx-auto flex justify-between items-center">
              <div className="flex gap-2">
                <Skeleton className="h-10 w-36" />
                <Skeleton className="h-10 w-32" />
              </div>
              <Skeleton className="h-10 w-32" />
            </div>
          </div>

          <div className="w-full max-w-none p-6 space-y-6">
            <Skeleton className="h-14 w-full max-w-2xl" />

            {[1, 2, 3].map((i) => (
              <Card key={i} className="border-ochre/10">
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <Skeleton className="h-6 w-48" />
                    <Skeleton className="h-8 w-24" />
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-3/4" />
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};
